// updated file of create service request
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import UploadFile from '../../Shared/UploadFile';
import Input from '../../Shared/Input';
import '../../../css/MarketPlace/CreateTransportationService.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import SuccessModal from '../../Shared/SuccessModal';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_ENDPOINT, LOOKUP_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
const CreateTransportationService = (props) => {
    const container = React.createRef();
    let history = useHistory();
    const userProfileDataR = props.userProfileDataRFun;
    const paramObj = useParams();
    const [errors, setErrors] = useState({});
    const [filePathRefDoc, setFilepathRefDoc] = useState('');
    const [commodityDropDown, setCommodityDropDown] = useState([]);
    const [textLength, setTextLength] = useState([]);
    const [dropDownRecord, setDropDownRecord] = useState([]);
    const [dropDownIndex, setDropDownIndex] = useState('');
    const [hasOpenSuccess, setHasOpenSuccess] = useState(false);
    const [values, setValues] = useState([]);
    const [tempValues, setTempValues] = useState([]);
    const [dateValue, setDateValue] = useState('');
    const [filterJson, setFilterJson] = useState([
        {
            "fieldId": 1001,
            "fieldName": "pickup_location",
            "displayName": "Pickup Location",
            "inputType": "input",
            "dropDownData": "",
            "validationType": "alpha",
            "requiredField": "yes",
            "fieldLookup": ""
        },
        {
            "fieldId": 1002,
            "fieldName": "destination",
            "displayName": "Destination",
            "inputType": "input",
            "dropDownData": "",
            "validationType": "alpha",
            "requiredField": "yes",
            "fieldLookup": ""
        },
        {
            "fieldId": 1003,
            "fieldName": "serviceWindowStartDateTime",
            "displayName": "Service Window Start Date & Time",
            "inputType": "calendarDateTime",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "yes",
            "fieldLookup": ""
        },
        {
            "fieldId": 1004,
            "fieldName": "serviceWindowEndDateTime",
            "displayName": "Service Window End Date & Time",
            "inputType": "calendarDateTime",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "yes",
            "fieldLookup": ""
        },
        {
            "fieldId": 1005,
            "fieldName": "container_size",
            "displayName": "No. of Containers",
            "inputType": "container",
            "dropDownData": "",
            "validationType": "num",
            "requiredField": "yes",
            "fieldLookup": ""
        },
        {
            "fieldId": 1006,
            "fieldName": "commodity",
            "displayName": "Commodity",
            "inputType": "dropdown",
            "dropDownData": '',
            "validationType": "",
            "requiredField": "No",
            "fieldLookup": "F_COMODITY"
        },
        {
            "fieldId": 1007,
            "fieldName": "truck_type_req",
            "displayName": "Truck Type Requirements",
            "inputType": "dropdown",
            "dropDownData": '',
            "validationType": "",
            "requiredField": "yes",
            "fieldLookup": "F_TRUCK_TYPE_REQ"
        },
        {
            "fieldId": 1008,
            "fieldName": "payment_terms",
            "displayName": "Payment Terms",
            "inputType": "dropdown",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "yes",
            "fieldLookup": "F_PAYMENT_TERMS"
        },
        {
            "fieldId": 1009,
            "fieldName": "requestClosingDate",
            "displayName": "Request Closing Date",
            "inputType": "calendarDate",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "yes",
            "fieldLookup": ""
        }, {
            "fieldId": 1010,
            "fieldName": "special_instructions",
            "displayName": "Special Instructions (Optional)",
            "inputType": "inputWithLimit",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "no",
            "fieldLookup": ""
        },
        {
            "fieldId": 1011,
            "fieldName": "upload_documents",
            "displayName": "Update Reference Documents (Optional)",
            "inputType": "upload",
            "dropDownData": "",
            "validationType": "",
            "requiredField": "no",
            "fieldLookup": ""
        },
    ]);
    const [calendarDate, setCalendarDate] = useState([]);
    const [calendarHour, setCalendarHour] = useState([]);
    const [calendarMin, setCalendarMin] = useState([]);
    const [dateToggle, setDateToggle] = useState([]);
    const [hourToggle, setHourToggle] = useState([]);
    const [minToggle, setMinToggle] = useState([]);
    const [headerServiceName, setHeaderServiceName] = useState('');
    const [serviceIdValue, setServiceIdValue] = useState(0);
    const hourValues = [{ hour: "00" }, { hour: "01" }, { hour: "02" }, { hour: "03" }, { hour: "04" }, { hour: "05" }, { hour: "06" }, { hour: "07" }, { hour: "08" }, { hour: "09" },
    { hour: "10" }, { hour: "11" }, { hour: "12" }, { hour: "13" }, { hour: "14" }, { hour: "15" }, { hour: "16" }, { hour: "17" }, { hour: "18" }, { hour: "19" },
    { hour: "20" }, { hour: "21" }, { hour: "22" }, { hour: "23" }];
    const minValues = [{ minit: "00" }, { minit: "01" }, { minit: "02" }, { minit: "03" }, { minit: "04" }, { minit: "05" }, { minit: "06" }, { minit: "07" }, { minit: "08" }, { minit: "09" },
    { minit: "10" }, { minit: "11" }, { minit: "12" }, { minit: "13" }, { minit: "14" }, { minit: "15" }, { minit: "16" }, { minit: "17" }, { minit: "18" }, { minit: "19" },
    { minit: "20" }, { minit: "21" }, { minit: "22" }, { minit: "23" }, { minit: "24" }, { minit: "25" }, { minit: "26" }, { minit: "27" }, { minit: "28" }, { minit: "29" },
    { minit: "30" }, { minit: "31" }, { minit: "32" }, { minit: "33" }, { minit: "34" }, { minit: "35" }, { minit: "36" }, { minit: "37" }, { minit: "38" }, { minit: "39" },
    { minit: "40" }, { minit: "41" }, { minit: "42" }, { minit: "43" }, { minit: "44" }, { minit: "45" }, { minit: "46" }, { minit: "47" }, { minit: "48" }, { minit: "49" },
    { minit: "50" }, { minit: "51" }, { minit: "52" }, { minit: "53" }, { minit: "54" }, { minit: "55" }, { minit: "56" }, { minit: "57" }, { minit: "58" }, { minit: "59" }];
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            let a = commodityDropDown;
            a[dropDownIndex] = false;
            setCommodityDropDown(a);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    useEffect(() => {
        const { serviceId, serviceName } = paramObj;
        setHeaderServiceName(serviceName);
        setServiceIdValue(serviceId);
        if (props.history.location.state) {
            setValues(props.history.location.state);
        }
    }, []);
    const fetchDropDownData = (index) => {
        var dropData = [];
        setDropDownRecord(dropData);
        var lookupType = filterJson[index]?.fieldLookup;
        console.log("type-", lookupType)
        ApiCall(
            'GET',
            utilityBaseURL + LOOKUP_ENDPOINT + `?lookupType=${lookupType}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setDropDownRecord(data);
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    const postCall = () => {
        const obj = {};
        for (let index = 0; index < filterJson.length; index++) {
            const element = values[index];
            const fieldNameTempp = filterJson[index].fieldName;
            obj[fieldNameTempp] = element;
        }
        console.log('temp obj', obj);
        console.log('temp string', JSON.stringify(obj));
        const cDataObj = JSON.parse(JSON.stringify(obj));
        delete cDataObj.serviceWindowStartDateTime;
        delete cDataObj.serviceWindowEndDateTime;
        delete cDataObj.requestClosingDate;
        delete cDataObj.payment_terms;
         console.log('cDataObj', cDataObj);
        // console.log('obj after', obj);
        // console.log('serviceWindowStartDateTime', obj?.serviceWindowStartDateTime, obj?.serviceWindowEndDateTime, obj?.requestClosingDate);
        // console.log('publishDateTime', new Date().getTime());

        if (isCalenderDateValidate(obj)) {
            ApiCall(
                'POST',
                serviceBaseURL + SERVICE_REQUEST_ENDPOINT,
                {
                    "baseService": {
                        "endDateTime": parseInt(obj?.serviceWindowEndDateTime),
                        "location": "",
                        "publishDateTime": new Date().getTime(),
                        "requestorCompanyName": userProfileDataR?.companyName,
                        "rfqDateTime": parseInt(obj?.requestClosingDate),
                        "serviceId": serviceIdValue,
                        "serviceName": headerServiceName,
                        "serviceType": headerServiceName,
                        "startDateTime": parseInt(obj?.serviceWindowStartDateTime),
                        "status": "Open",
                        "paymentTerm": obj?.payment_terms
                    },
                    "fieldsData": cDataObj,
                    "docPath": ""
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        setHasOpenSuccess(true);
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }

    }
    const isCalenderDateValidate = (obj) => {
        let isValid = true
        if (isValid) {
            let errors = {};
            let isRFQValid = obj?.requestClosingDate < obj?.serviceWindowStartDateTime;
            let isStartValid = (obj?.requestClosingDate < obj?.serviceWindowStartDateTime) && (obj?.serviceWindowStartDateTime < obj?.serviceWindowEndDateTime);
            let isEndValid = obj?.serviceWindowEndDateTime > obj?.serviceWindowStartDateTime;
            if (!isRFQValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "requestClosingDate") {
                        errors[filterJson[index].displayName] = 'Must be before Service Start Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            if (!isStartValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "serviceWindowStartDateTime") {
                        errors[filterJson[index].displayName] = 'Must be between Request Closing and Service End Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            if (!isEndValid) {
                for (let index = 0; index < filterJson.length; index++) {
                    if (filterJson[index].fieldName == "serviceWindowEndDateTime") {
                        errors[filterJson[index].displayName] = 'Must be after Service Start Date';
                        document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                    }
                }
                setErrors(errors);
            }
            isValid = isValid && isRFQValid && isStartValid && isEndValid;
            return isValid;
        }
    }
    const handleChangeInput = (e, index, displayName) => {
        if (filterJson[index].inputType == 'inputWithLimit' && e.target.value.length <= 500) {
            textLength[index] = e.target.value.length;
            setTextLength(textLength);
            console.log('err text', textLength);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        } else {
            console.log('err displa', displayName);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const validate = () => {
        let errors = {};
        let formIsValid = true;
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternAlphaNumeric = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
        for (let index = 0; index < filterJson.length; index++) {
            const element = values[index];
            if (!element && filterJson[index].requiredField == 'yes') {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.required;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            } else if (element && !patternCharacter.test(element) && filterJson[index].validationType == 'alpha') {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.alpha;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            } else if (element && !patternDigit.test(element) && filterJson[index].validationType == 'num') {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.num;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            } else if (element && !patternAlphaNumeric.test(element) && filterJson[index].validationType == 'alphanum') {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.alphanum;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.black;
            }
            //upload file border only
            if (filterJson[index].inputType == 'upload' && !element && filterJson[index].requiredField == 'yes') {
                document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.red;
            }
            else if (filterJson[index].inputType == 'upload' && element) {
                document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.black;
            }
            // calender time and min border only
            if (filterJson[index].inputType == 'calendarDateTime' && !element && filterJson[index].requiredField == 'yes') {
                document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.red;
            } else if (filterJson[index].inputType == 'calendarDateTime' && element) {
                document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    const validateContainerDetails = () => {
        let errors = {};
        let count = true;
        if (count) {
            for (let index = 0; index < filterJson.length; index++) {
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.black;
                if (filterJson[index].inputType == 'calendarDateTime') {
                    document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.black;
                }
            }
            count = false;
        }
        let formIsValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        for (let index = 0; index < filterJson.length; index++) {
            const element = values[index];
            if (!element && filterJson[index].requiredField == 'yes') {
                if (filterJson[index].fieldId == 1001 || filterJson[index].fieldId == 1002 || filterJson[index].fieldId == 1005 || filterJson[index].fieldId == 1007) {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.required;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                }
            } else if (element && !patternDigit.test(element) && filterJson[index].validationType == 'num' && filterJson[index].fieldId == 1005) {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.num;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            } else if (element && patternDigit.test(element) && filterJson[index].validationType == 'num' && filterJson[index].fieldId == 1005 && (element < 1 || element > 10)) {
                formIsValid = false;
                errors[filterJson[index].displayName] = "Please enter number between 1 to 10.";
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            }
            else if (element && !patternCharacter.test(element) && filterJson[index].validationType == 'alpha' && (filterJson[index].fieldId == 1001 || filterJson[index].fieldId == 1002)) {
                formIsValid = false;
                errors[filterJson[index].displayName] = Message.validation.alpha;
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
            }
            else {
                document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    const toggleDropDown = (index) => {
        setDropDownIndex(index);
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
        fetchDropDownData(index);
    };
    const toggleDate = (index) => {
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
    }
    const toggleHour = (index) => {
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
    }
    const toggleMin = (index) => {
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
    }
    const onSubmit = () => {
        console.log('before validate-', values);
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'calendarDateTime') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15) + ' '
                    + calendarHour[index] + ':' + calendarMin[index];
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            } else if (filterJson[index].inputType == 'calendarDate') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15);
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            }
        }
        console.log('validate-', values);
        if (validate()) {
            console.log('submit val-', values);
            postCall();
        }
    }
    const changeDropDownValue = (e, index) => {
        const found = dropDownRecord?.find((name) => {
            if (name?.lookupCode === e.target.innerText) {
                return name
            }
        })
        values[index] = found?.lookupCode;
        setValues(values);
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
        console.log('val--', values)
        let displayName = filterJson[index].displayName;
        let var1 = errors[displayName] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const removeUpdateReferenceDocumentsLink = () => {
        let path = "";
        setFilepathRefDoc(path);
    }
    const uploadFileFun = (uploadConfirm) => {
    }
    const setUploadLinkUpdateReferenceDocuments = (filePathURL) => {
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'upload') {
                values[index] = filePathURL;
                setValues(values);
            }
        }
        setFilepathRefDoc(filePathURL);
    }
    const setLoaderUpdateReferenceDocuments = (filePathURL) => {
    }
    const getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    const handleChangeDate = (e, index, fieldId) => {
        calendarDate[index] = getDateFormated(e);
        setCalendarDate(calendarDate);
        console.log('cale--', calendarDate);
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        if (fieldId == 1003) {
            let minDateValue = new Date(e.getTime() + (1000 * 60 * 60 * 24));
            let maxDateValue = new Date(e.getTime() - (1000 * 60 * 60 * 24));
            tempValues.push(minDateValue);
            tempValues.push(maxDateValue);
        }
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change min and hour boder
        if (filterJson[index].inputType == 'calendarDateTime') {
            let fieldNameTemp = filterJson[index].fieldName;
            document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const handleChangeHour = (e, index) => {
        const found = hourValues.find((name) => {
            if (name.hour === e.target.innerText) {
                return name
            }
        })
        calendarHour[index] = found.hour;
        setCalendarHour(calendarHour);
        console.log('hour', calendarHour)
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeMin = (e, index) => {
        const found = minValues.find((name) => {
            if (name.minit === e.target.innerText) {
                return name
            }
        })
        calendarMin[index] = found.minit;
        setCalendarMin(calendarMin);
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const EnterContainerNoFunction = () => {
        console.log("abc-----d", values[4], values[0], values[1], values[6]);
        if (validateContainerDetails()) {
            if (values[4]) {
                props.history.push({
                    pathname: `/QuotationContainerDetails/${serviceIdValue}/${headerServiceName}/${values[4]}/${values[0]}/${values[1]}/${values[6]}`,
                    state: values
                })
            }
        }
    }
    const onCloseModal = () => {
        setHasOpenSuccess(false);
        history.push('/ServiceSelection');
    };
    return (
        <div class="CreateResponseFormOutercolor">
            <MetaDecorator title={TitleDescription.CreateServiceRequestGSTitle} description={TitleDescription.CreateServiceRequestGSDescription} />
            <Header tilesFetched={() => { }} />
            <div class="CreateResponseFormOuterDivcss">
                <div id="CreateResponseFormBoxDiv">
                    <nav class="CreateResponseFormNavbar">
                        <div className="CreateResponseFormNavbarName">
                            <small id="CreateResponseFormNavbarText">{headerServiceName}</small>
                        </div>
                    </nav>
                    <hr class="hr1" />
                    <div class="CreateResponseFormMidPartition">
                        <div class="CreateResponseFormHeadingText">Service Request Details</div>
                        <div class="CreateResponseFormCardcss">
                            {filterJson.map((name, index) => {
                                return (
                                    <>
                                        {(name.inputType == 'input' || name.inputType == 'inputWithLimit') &&
                                            <div class="CreateResponseFormInpSize">
                                                <small id="CreateResponseFormInpHeading">{name.displayName}</small>
                                                <div className="pass-wrapper" id="CreateResponseFormInpDiv" >
                                                    <Input
                                                        name={name.displayName}
                                                        class="input CreateResponseFormInpCss" placeholder={name.displayName == "Special Instructions (Optional)" ? "Enter Special Requirements" : `Enter ${name.displayName}`}
                                                        type="text" id={name.fieldName} value={values[index]}
                                                        onChange={(e) => handleChangeInput(e, index, name.displayName)}
                                                    />
                                                    <div className="CreateResponseFormError">{errors[name.displayName]}</div>
                                                    {name.inputType == 'inputWithLimit' &&
                                                        <small class="CreateResponseFormCommentTextlmt">{textLength[index] ? textLength[index] : 0}/500</small>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {name.inputType == 'container' &&
                                            <div class="CreateResponseFormInpSize">
                                                <small id="CreateResponseFormInpHeading">{name.displayName}</small>
                                                <div id="CreateResponseFormContainerDiv">
                                                    <div className="pass-wrapper" id="CreateResponseFormContainerInputDiv" >
                                                        <Input
                                                            name={name.displayName}
                                                            class="input CreateResponseFormInpCss" placeholder="Enter No"
                                                            type="text" id={name.fieldName} value={values[index]}
                                                            onChange={(e) => handleChangeInput(e, index, name.displayName)}
                                                        />
                                                        <div className="CreateResponseFormError">{errors[name.displayName]}</div>
                                                    </div>
                                                    <div id="CreateResponseFormContainerNo" onClick={EnterContainerNoFunction}>Enter Container No.</div>
                                                </div>
                                            </div>
                                        }
                                        {name.inputType == 'dropdown' &&
                                            <div class="CreateResponseFormInpSize">
                                                <small id="CreateResponseFormInpHeading">{name.displayName}</small>
                                                <div className="pass-wrapper" id="CreateResponseFormInpDiv" >
                                                    <Input
                                                        readOnly
                                                        name={name.displayName} placeholder={`Select ${name.displayName}`}
                                                        type="text" class={commodityDropDown[index] ? "CreateResponseFormBtmBorderLessCss input" : "CreateResponseFormInpDropCss input"}
                                                        value={values[index]}
                                                    />
                                                    <div className="CreateResponseFormDropError">{errors[name.displayName]}</div>
                                                    <i id="CreateResponseFormInp_imgDrop" onClick={() => toggleDropDown(index)}>
                                                        <img src={commodityDropDown[index] ? uparrow : downarrow} />
                                                    </i>
                                                </div>
                                                {commodityDropDown[index] && (
                                                    <div class="CreateResponseFormDropDowmDiv" >
                                                        <div class="CreateResponseFormDropCard" ref={container} >
                                                            {(dropDownRecord?.map((data, i) => {
                                                                return (
                                                                    <DropDownTable id="CreateResponseFormDropRowSize" onClick={(e) => changeDropDownValue(e, index)}>
                                                                        <small class="" id="CreateResponseFormDropRowText" >{data?.lookupCode} </small>
                                                                    </DropDownTable>
                                                                );
                                                            }))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        {name.inputType == 'upload' &&
                                            <div class="CreateResponseFormInpSize">
                                                <small id="CreateResponseFormInpHeading">{name.displayName}</small>
                                                <div className="pass-wrapper" id="CreateResponseFormInpDiv" >
                                                    <UploadFile uploaddivid={name.displayName} idupload="upload"
                                                        name={name.displayName}
                                                        fileType="jpeg, jpg, png, pdf"
                                                        setUploadConfirm={uploadFileFun}
                                                        removeLink={removeUpdateReferenceDocumentsLink}
                                                        upload_link="cipcUpload" uploadicon="cipcIcon"
                                                        setFileLink={setUploadLinkUpdateReferenceDocuments}
                                                        setLoader={setLoaderUpdateReferenceDocuments}
                                                        staticFileName={'Update_Reference_Documents.'}
                                                    />
                                                    <div className="CreateResponseFormError">{errors[name.displayName]}</div>
                                                </div>
                                            </div>
                                        }
                                        {(name.inputType == 'calendarDateTime' || name.inputType == 'calendarDate') &&
                                            <div class="CreateResponseFormInpSize">
                                                <small id="CreateResponseFormInpHeading">{name.displayName}</small>
                                                <div id="CreateResponseFormCalOuterDiv">
                                                    <div className="pass-wrapper" id={name.inputType == 'calendarDate' ? "CreateResponseFormInpDiv" : "CreateResponseFormCalendarDiv"}>
                                                        <input
                                                            readOnly
                                                            class="inpuut1 CreateResponseFormCalSWCss"
                                                            placeholder={name.displayName == "Request Closing Date" ? "Enter Request Closing Date" : "Select Date"}
                                                            type="text"
                                                            id={name.fieldName}
                                                            name={name.displayName}
                                                            autoComplete="off"
                                                            value={calendarDate[index]}
                                                        />
                                                        <div className={(name.fieldName == "serviceWindowStartDateTime" || name.fieldName == "serviceWindowEndDateTime") ? "CreateResponseFormDropError CreateResponseFormCalWidthCss" : "CreateResponseFormDropError"}>{errors[name.displayName]}</div>
                                                        <div class="CreateResponseFormSWCalendarWidth">  {dateToggle[index] ?
                                                            <div ref={container}>
                                                                <Calendar onChange={(e) => handleChangeDate(e, index, name.fieldId)}
                                                                    minDate={tempValues.length == 0 ? new Date() : (name.fieldName == "serviceWindowEndDateTime" ? tempValues[0] : new Date())}
                                                                    maxDate={name.fieldName == "requestClosingDate" ? tempValues[1] : null}
                                                                />
                                                            </div> : null}
                                                        </div>
                                                        <img id={name.inputType == 'calendarDate' ? "CreateResponseFormInp_imgCal" : "CreateResponseFormSWCal_imgCal"} src={calender} alt="" onClick={() => toggleDate(index)}
                                                        />
                                                    </div>
                                                    {name.inputType == 'calendarDateTime' &&
                                                        <div id={hourToggle[index] ? "CreateResponseFormHourDiv" : (minToggle[index] ? "CreateResponseFormMinitDiv" : "CreateResponseFormHTDiv")} name={name.fieldName}>
                                                            <div id="CreateResponseFormHHDiv" >
                                                                <div className="pass-wrapper" id="CreateResponseFormInpDiv" >
                                                                    <Input
                                                                        readOnly name="SWStartHour" class="CreateResponseFormHTDropCss" placeholder="HH"
                                                                        type="text" value={calendarHour[index]}
                                                                    />
                                                                    <i id="CreateResponseFormHHMM_imgDrop" onClick={() => toggleHour(index)}>
                                                                        {hourToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                                    </i>
                                                                </div>
                                                                {hourToggle[index] && (
                                                                    <div class="CreateResponseFormDropDowmDiv" >
                                                                        <div class="CreateResponseFormHMDropCard" ref={container} >
                                                                            {(hourValues?.map((data, i) => {
                                                                                return (
                                                                                    <DropDownTable onClick={(e) => handleChangeHour(e, index)} id="CreateResponseFormHHMMRowSize">
                                                                                        <small class="" id="CreateResponseFormDropRowText" >{data.hour} </small>
                                                                                    </DropDownTable>
                                                                                );
                                                                            }))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div id="CreateResponseFormTTDiv">
                                                                <div className="pass-wrapper" id="CreateResponseFormInpDiv" >
                                                                    <Input
                                                                        readOnly name="SWStartMinit" class="CreateResponseFormHTDropCss" placeholder="MM"
                                                                        type="text" value={calendarMin[index]}
                                                                    />
                                                                    <i id="CreateResponseFormMinit_imgDrop" onClick={() => toggleMin(index)}>
                                                                        {minToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                                    </i>
                                                                </div>
                                                                {minToggle[index] && (
                                                                    <div class="CreateResponseFormDropDowmDiv" >
                                                                        <div class="CreateResponseFormHMDropCard" ref={container} >
                                                                            {(minValues.map((name, i) => {
                                                                                return (
                                                                                    <DropDownTable onClick={(e) => handleChangeMin(e, index)} id="CreateResponseFormHHMMRowSize">
                                                                                        <small class="" id="CreateResponseFormDropRowText" >{name.minit} </small>
                                                                                    </DropDownTable>
                                                                                );
                                                                            }))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </>
                                )
                            })
                            }
                        </div>
                        <div class="CreateResponseFormBtnDiv">
                            <Button class="CreateResponseFormBtnCss" onClick={() => onSubmit()}>
                                <small class="CreateResponseFormBtntext">Submit Request</small>
                            </Button>
                        </div>
                    </div>
                </div>
                <div class="CreateResponseFormFooterUnfixed">
                    <Footer />
                </div>
                <div class="CreateResponseFormFooterFixed">
                    <Footer2 />
                </div>
            </div >
            <SuccessModal hasOpen={hasOpenSuccess} onCloseModal={onCloseModal}>
                <div>
                    <div class="successRatingdivout">
                        <small class="successRatingdivsm">Your response has been submitted
                        </small>
                        <small class="successRatingdivsm"> successfully.</small>
                    </div>
                </div>
            </SuccessModal>
        </div>
    )
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataRFun: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
        }
    }
}
export default connect(mapStateToProps)(CreateTransportationService);